<script lang="ts">
	import { createEventDispatcher, tick } from 'svelte';
	import { format } from 'svelte-i18n';
	import { toast } from '@Shelly/shelly-design-system';
	import EmptyElementMsgAndBtn from './EmptyElementMsgAndBtn.svelte';
	import WhenPreviewWithControl from './components/WhenPreviewWithControl.svelte';
	import {
		delete_condition_from_whens,
		update_scene_whit_new_whens,
		add_condition,
		edit_condition,
	} from '../manage_scene_elements';
	import {
		_deepClone,
		_deepCopyArr,
		deepCopy,
		value_from_percent_range,
	} from '../../../../helpers/utilities';
	import {
		createDeviceCondition,
		createDeviceTrigger,
		createTimeBasedCondition,
		createWeatherCondition,
		createSceneAsTrigger,
		create_sunrise_sunset_trigger,
		create_exchange_based,
		create_math_condition as createMathCondition,
		create_manual_execution_condition,
	} from '../../helpers/ui_conditions_to_scene';
	import {
		createDeviceID,
		get_mode,
		isBluTRV,
		tmp_units_from_settings,
	} from '../../../../helpers/interface_helpers';
	import { getSceneConditions } from '../../helpers/scene_data_helpers';
	import { readDeviceStatus, readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { devices } from 'src/stores/lists/devices';
	import { rooms } from 'src/stores/lists/rooms';
	import { real_id } from '../../../../helpers/interface_helpers';
	import type { ISceneObj } from '../../../../types/SceneType';

	import AddEditConditionWizardV2 from '../Process/When/AddEditContionWizard/AddEditConditionWizardV2.svelte';
	import ImportConditionsModal from '../Process/ImportFromSceneModal/ImportConditionsModal.svelte';
	import ConditionTypeSelectionModal from '../Process/SelectTypeModal/ConditionTypeSelectionModal.svelte';
	import { conditionInterpretator } from '../../helpers/scene_conditions_to_ui';
	import { defaultDeviceCondition } from '../Process/When/AddEditContionWizard/helpers/when-wizard-helpers';
	import { addRemoveDeviceIdsFromMetaInSceneObject } from '../Process/GenericComponents/helpers';

	export let scene_object: ISceneObj;
	export let showAddEditCondition = false;
	export let hideWhens = false;
	export let element: any = {};
	export let when_info = { mode: 'add', type: 'or', main_ind: -1, sub_ind: -1 };
	export let saveEditSteps = false;
	export let stopConfirmationModal = false;
	export let backdropCloseModal = false;

	let showTypeSelectionModal = false;
	let showImportModal = false;

	const dispatch = createEventDispatcher();
	const EMPTY_EXTRACT_PROPS = {};

	const defaultSceneData = {
		when_info,
		scene: element,
		selectedCondition: 1,
		extractPropsFromSelectedCond: EMPTY_EXTRACT_PROPS,
		_device_condition: defaultDeviceCondition,
		devicePropsOptions: [],
		selectedDevice: {},
		selectedDeviceProp: {},
		components: [],
		_time_trigger_obj: {
			id: -1,
			value: -1,
			_gui_type: undefined,
		},
		active_condition: {
			cond_name: 'energy_exchange',
			operator: '',
			value: 0,
			exchange_market: '',
			character: '',
			minutes: 0,
		},
		_automation_condition: {
			scene_id: '',
			selected: false,
		},
		_sunrise_sunset_cond: {
			hours: 0,
			mins: 0,
			type: 'sunrise',
			beforeAfter: 'before',
			locid: '',
		},
		weatherCondition: {
			cond: '',
			value: '',
			op: '',
			locid: '',
			hours: 0,
			execution_type: 'once',
		},
		_math_condition: {
			math_script: {},
			expression: '',
			params: [],
		},
		selectedWatchType: 'trigger',
		watchProp: {
			cond_type_id: 1,
			cond_type_name: 'once',
			valid_for_min: 0,
		},
		translated: undefined,
		isValid: false,
		validStepIndex: 0,
	};

	let sceneData = { ...defaultSceneData };

	// let text = $format('when').toUpperCase();

	function generateWhenConditions(scene_object) {
		return getSceneConditions(scene_object);
	}

	let whens = generateWhenConditions(scene_object);

	/** MANAGE ACTIONS FROM ADD/EDIT/DELETE BUTTONS FOR CONDITIONS*/
	/** on delete we find out the condition position and remove it from the whens
	 * and update the scene_object with new data
	 */
	const handle_delete = (e) => {
		when_info = { ...e.detail, mode: 'delete' };

		let _copy_whens = _deepCopyArr(whens);

		whens = delete_condition_from_whens(_copy_whens, when_info.main_ind, when_info.sub_ind);

		scene_object = addRemoveDeviceIdsFromMetaInSceneObject(
			'condition',
			_copy_whens?.[when_info.main_ind]?.[when_info.type]?.[when_info.sub_ind],
			scene_object,
		);

		// let _copy_scene = _deepClone(scene_object);
		// scene_object = _deepClone(
		// 	update_scene_whit_new_whens(_copy_scene, whens)
		// ) as ISceneObj;
		scene_object = update_scene_whit_new_whens(scene_object, whens);
		console.log('updated is afer delete ', JSON.stringify(scene_object.if, null, 2));
		when_info = { mode: 'add', type: 'or', main_ind: -1, sub_ind: -1 };
	};

	/**on edit we just update the when_info object and pass it to the Child component*/
	const handle_edit = async (e) => {
		when_info = { ...e.detail, mode: 'edit' };
		element =
			when_info.main_ind >= 0 && when_info.sub_ind >= 0
				? whens[when_info.main_ind]['and'][when_info.sub_ind]
				: undefined;

		scene_object = addRemoveDeviceIdsFromMetaInSceneObject('condition', element, scene_object);

		await tick();
		showAddEditCondition = true;
	};
	/**on add we just update the when_info object and pass it to the Child component*/
	const handle_add = (e) => {
		when_info = { ...e.detail, mode: 'add' };
		element = undefined;
		showTypeSelectionModal = true;
		// Old implementation footer should not be hidden in the new flow
		// dispatch('hide_footer', { hideFooter: showAddEditCondition });
	};

	const handle_add_first = () => {
		when_info = { mode: 'add', type: 'or', main_ind: -1, sub_ind: -1 };
		element = undefined;
		showTypeSelectionModal = true;
		// Old implementation footer should not be hidden in the new flow
		// dispatch('hide_footer', { hideFooter: showAddEditCondition });
	};
	/**it comes from Child component,, we just restore the */
	const handle_cancel = () => {
		showAddEditCondition = false;
		when_info = { mode: 'add', type: 'or', main_ind: -1, sub_ind: -1 };
		element = undefined;
		// Old implementation footer should not be hidden in the new flow
		// dispatch('hide_footer', { hideFooter: showAddEditCondition });
	};

	/** END ACTIONS FROM ADD?EDIT?DELETE buttons*/

	function convertElByType(t_data, c_obj, s_type) {
		let newEl = {};

		switch (s_type) {
			case 'condition':
			case 'trigger':
				const _device = $devices[t_data?.device.id];
				let dev_id = createDeviceID(t_data?.device?.id, t_data?.device?.channel, _device?.type);

				let more = {
					dev_mode: get_mode(
						$devices[dev_id],
						readDeviceStatus(real_id(dev_id)),
						readDeviceSettings(real_id(dev_id)),
					),
					units_conversion: tmp_units_from_settings(
						!isBluTRV($devices[dev_id]?.type)
							? readDeviceSettings(real_id(dev_id))
							: $devices[dev_id],
					).match(/F/)
						? true
						: false,
				};
				const selectedChannel =
					t_data?.channel ||
					t_data?.remote_control_channel ||
					sceneData?._device_condition?.channel ||
					undefined;
				newEl =
					s_type === 'trigger'
						? createDeviceTrigger(t_data, c_obj, more, {
								channel: selectedChannel,
							})
						: createDeviceCondition(t_data, more, { channel: selectedChannel });
				return newEl;
			case 'time_trigger':
				newEl = createTimeBasedCondition(t_data);
				console.log('new time based trigger ', JSON.stringify(newEl, null, 2));
				return newEl;
			case 'weather_trigger':
				newEl = createWeatherCondition(t_data);
				console.log('new weather cond ', JSON.stringify(newEl, null, 2));
				return newEl;
			case 'math_trigger':
				newEl = createMathCondition(t_data);
				console.log('new math cond ', JSON.stringify(newEl, null, 2));
				return newEl;
			case 'sun_trigger':
				newEl = create_sunrise_sunset_trigger(t_data);
				console.log('new el for sun:set/rise trigger ', JSON.stringify(newEl));
				return newEl;
			case 'automation':
				// console.log('selected scene id ', t_data, s_type, c_obj);
				newEl = createSceneAsTrigger(t_data);
				console.log('activated scene condition ', newEl);
				return newEl;
			case 'exchange_based':
				console.log('data for element and price ', t_data);
				newEl = create_exchange_based(t_data);
				return newEl;
			case 'manual_execution':
				// console.log('manual execution condition ', t_data);
				newEl = create_manual_execution_condition(t_data);
				return newEl;
			default:
				return;
		}
	}

	function sceneObject(new_and_str, scene_object) {
		let sceneEl = {};
		switch (when_info.mode) {
			case 'add':
				sceneEl = add_condition(scene_object, new_and_str, when_info.type, when_info.main_ind);
				// console.warn('WIth new condition ', JSON.stringify(sceneEl, null, 2));
				return sceneEl;

			case 'edit':
				console.log('scene_object Before', scene_object);
				sceneEl = edit_condition(scene_object, when_info, new_and_str);
				console.warn('scene_object Aftrer', sceneEl);
				return sceneEl;

			default:
				toast.open({
					type: 'danger',
					title: $format('operation_failed', { default: 'Operation failed' }),
				});
				return scene_object;
		}
	}

	const handle_save = (e) => {
		let new_el;
		const { t_data, c_obj, s_type } = e.detail;
		// 1. validate data before try to create new element
		// 2. create new element
		// 3. find possition where it must be put on
		// 4. copy scene and put the new object

		const cond_data =
			t_data?.cond_name === 'white_channel'
				? {
						...t_data,
						cond_name: 'w',
						value: value_from_percent_range(t_data.value, [0, 255]),
					}
				: t_data;

		new_el = convertElByType(cond_data, c_obj, s_type);

		if (typeof new_el === 'undefined') {
			toast.open({
				type: 'danger',
				title: $format('scene_invalid_format_err_toast'),
			});
			return;
		}
		const new_and_str = {
			and: [new_el],
		};

		//save new el on pos
		scene_object = sceneObject(new_and_str, scene_object);

		if (cond_data.hasOwnProperty('device')) {
			let dev_id =
				Number(cond_data.device.channel) > 0
					? `${cond_data.device.id}_${cond_data.device.channel}`
					: cond_data.device.id;

			if (scene_object._meta.hasOwnProperty('cdi') && Array.isArray(scene_object._meta.cdi)) {
				if (!scene_object._meta.cdi.includes(dev_id)) {
					scene_object._meta.cdi.push(dev_id);
				}
			} else {
				scene_object._meta = {
					...scene_object._meta,
					cdi: [dev_id],
				};
			}
		}

		showAddEditCondition = false;
		whens = generateWhenConditions(scene_object);
		// Old implementation footer should not be hidden in the new flow
		// dispatch('hide_footer', { hideFooter: showAddEditCondition });

		onCloseAddEditActionWizard();

		if (saveEditSteps) {
			dispatch('save');
		}
	};

	const onCloseAddEditActionWizard = () => {
		showAddEditCondition = false;
		resetSceneData();
	};

	const resetSceneData = () => {
		sceneData = deepCopy({ ...defaultSceneData });
	};

	const handleImportConditions = (e) => {
		const { items } = e.detail;

		// Collect all conditions into a single 'and' array
		const allConditions = items.map((importedItem) => importedItem.item);

		// Create a single 'and' structure with all conditions
		let new_and_str = {
			and: allConditions,
		};

		// R.K
		// Add all conditions using the when_info context,
		// either 'or' or 'and', depending on the clicked button
		scene_object = add_condition(scene_object, new_and_str, when_info.type, when_info.main_ind);

		// Handle device tracking in meta for all imported conditions
		items.forEach((importedItem) => {
			const condition = importedItem.item;
			if (condition.hasOwnProperty('devid') || condition.hasOwnProperty('d')) {
				const dev_id = condition.devid || condition.d;

				if (scene_object._meta.hasOwnProperty('cdi') && Array.isArray(scene_object._meta.cdi)) {
					if (!scene_object._meta.cdi.includes(dev_id)) {
						scene_object._meta.cdi.push(dev_id);
					}
				} else {
					scene_object._meta = {
						...scene_object._meta,
						cdi: [dev_id],
					};
				}
			}
		});

		// Update whens after import
		whens = generateWhenConditions(scene_object);
		showImportModal = false;

		if (saveEditSteps) {
			dispatch('save');
		}

		toast.open({
			type: 'success',
			title: $format('conditions_imported_successfully', {
				default: 'Conditions imported successfully',
			}),
		});
	};

	const setSceneDataTranslated = (element) => {
		const purpose = element?._gui_type || element?._gui_purpose || undefined;
		return when_info.mode === 'add' || typeof element === 'undefined'
			? undefined
			: conditionInterpretator(element, purpose);
	};

	$: translated = setSceneDataTranslated(element);

	$: {
		const extractProps =
			[...sceneData.components].find((el) => {
				return typeof el.props.add_info_ind !== 'undefined'
					? `${el.props.id}${el.props.add_info_ind}` === sceneData.selectedDeviceProp.value
					: typeof el.props.input_index !== 'undefined'
						? `${el.props.id}${el.props.input_index}` === sceneData.selectedDeviceProp.value
						: el.props.id === sceneData.selectedDeviceProp.value;
			})?.props || EMPTY_EXTRACT_PROPS;

		if (sceneData.extractPropsFromSelectedCond !== extractProps) {
			sceneData.extractPropsFromSelectedCond = extractProps;
		}

		if (sceneData.scene !== element) {
			sceneData.scene = element;
		}
		if (sceneData.when_info !== when_info) {
			sceneData.when_info = when_info;
		}
		if (sceneData.translated !== translated) {
			sceneData.translated = translated;
		}
	}
</script>

{#if !hideWhens}
	{#if whens.length > 0}
		<!-- Display conditions -->
		<WhenPreviewWithControl
			bind:whens
			on:delete={(e) => handle_delete(e)}
			on:edit={(e) => handle_edit(e)}
			on:add={(e) => handle_add(e)}
		/>
	{:else}
		<!-- Missing condition + Add button-->
		<EmptyElementMsgAndBtn type={'condition'} on:click={() => handle_add_first()} />
	{/if}
{/if}

{#if showAddEditCondition}
	<AddEditConditionWizardV2
		showWizard={showAddEditCondition}
		backdropClose={backdropCloseModal}
		rawSceneObject={scene_object}
		{stopConfirmationModal}
		bind:sceneData
		on:save={(e) => handle_save(e)}
		on:close={() => {
			showAddEditCondition = false;
			resetSceneData();
		}}
		on:back={() => {
			showAddEditCondition = false;
			showTypeSelectionModal = true;
		}}
	/>
{/if}

{#if showTypeSelectionModal}
	<ConditionTypeSelectionModal
		bind:showModal={showTypeSelectionModal}
		on:create={() => {
			showTypeSelectionModal = false;
			showAddEditCondition = true;
		}}
		on:import={() => {
			showTypeSelectionModal = false;
			showImportModal = true;
		}}
		on:close={() => {
			showTypeSelectionModal = false;
		}}
	/>
{/if}

{#if showImportModal}
	<ImportConditionsModal
		bind:showModal={showImportModal}
		currentSceneId={scene_object._id}
		on:import={handleImportConditions}
		on:close={() => {
			showImportModal = false;
			showTypeSelectionModal = true;
		}}
	/>
{/if}
